import { IoChevronBackOutline } from "react-icons/io5";
import styled from "styled-components";

const Nav = styled.nav`
  width: 100%;
  padding: 10px;
  height:70px;
  background: white;
  text-align: right !important;
  .logo {
    padding: 15px 0;
  }
`;

const SecoundaryHeader = props => {
  // const history = useHistory();

  const back = () => {
    props.onBack();
  };
  return (
    <Nav
      className="navbar fixed-top navbar-light"
      style={{ background: props.color ? props.color : "" }}
    >
      <div className="d-flex flex-row justify-content-between w-100">
        <div className="d-flex flex-row">
          <div onClick={back} className="text-left align-self-center">
            <IoChevronBackOutline
              style={{ width: "28px", height: "28px", color: "#434343" }}
            />
          </div>
          <div
            className="text-left nav-title"
            style={{
              color: props.textColor ? props.textColor : "#434343",
              alignSelf: "center",
              marginLeft: "10px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            {props.text}
          </div>
        </div>
        <div>
          {!props.sideHide && (
            <div>
              {props.extra ? (
                props.extra()
              ) : (
                <img
                  src={
                    require("../../assets/images/topbar/Notification.png")
                      .default
                  }
                  alt="act"
                  style={{ width: "20px", marginRight: " 10px" }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Nav>
  );
};

export default SecoundaryHeader;
